import { CustomerAddressInput } from '~/modules/GraphQL/types';

const mapCustomAttributes = (input: { code: string; value: string }[]) => input.map((attr) => ({ attribute_code: attr.code, value: attr.value }));

export const transformUserCreateAddressInput = (addressInputParams): CustomerAddressInput => {
  const {
    apartment,
    neighborhood,
    extra,
    customAttributes,
    ...address
  } = addressInputParams.address;

  const street = Array.isArray(address.street) ? address.street : [address.street];

  if (apartment) street.push(apartment);

  if (neighborhood) street.push(neighborhood);

  if (extra) street.push(extra);

  let mappedCustomAttributes = [];
  if (customAttributes) {
    mappedCustomAttributes = mapCustomAttributes(customAttributes as { code: string; value: string }[]);
  }

  return {
    ...address,
    street,
    ...(mappedCustomAttributes.length > 0 && { custom_attributesV2: mappedCustomAttributes }),
  };
};

export const transformUserUpdateAddressInput = (addressInputParams): {
  addressId: number;
  input: CustomerAddressInput;
} => {
  const {
    apartment,
    neighborhood,
    extra,
    id,
    customAttributes,
    // @ts-ignore
    // eslint-disable-next-line
    extension_attributes,
    // @ts-ignore
    // eslint-disable-next-line no-underscore-dangle
    __typename: typenameAddress,
    ...address
  } = addressInputParams.address;

  const {
    // @ts-ignore
    // eslint-disable-next-line no-underscore-dangle
    __typename: typenameRegion,
    ...region
  } = address.region;

  const street = Array.isArray(address.street) ? address.street : [address.street];

  if (apartment) street.push(apartment);

  if (neighborhood) street.push(neighborhood);

  if (extra) street.push(extra);

  let mappedCustomAttributes = [];
  if (customAttributes) {
    mappedCustomAttributes = mapCustomAttributes(customAttributes as { code: string; value: string }[]);
  }

  const addressParams: CustomerAddressInput = {
    ...address,
    region,
    street: street.filter(Boolean),
    ...(mappedCustomAttributes.length > 0 && { custom_attributesV2: mappedCustomAttributes }),
  };

  return {
    addressId: id,
    input: {
      ...addressParams,
    },
  };
};

export const transformUserGetter = (addressInput) => {
  const addressData = addressInput;
  const customAttributes = addressInput.custom_attributesV2;
  delete addressData.custom_attributesV2;

  return {
    ...addressData,
    street: addressData.street[0],
    apartment: addressData.street[1],
    neighborhood: addressData.street[2],
    extra: addressData.street[3],
    customAttributes,
  };
};
